<div class="modal active">
    <div class="modal__container modal__container--md">
        <div class="fields">
            <h2>Routes Import Options</h2>
            <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
              <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
                <div class="fields__block">
                    <div class="fields__block__section">
                        <div class="title">
                            <h4>Routes to Import</h4>
                            <span> </span>
                        </div>
                        <div class="table-fields">
                            <div class="filter">
                                <a (click)="selectAll()" style="cursor: pointer">Select All</a>
                                <a (click)="deselectAll()" style="cursor: pointer">Deselect All</a>
                            </div>
                            <div style="height: 240px; overflow-y:auto;">
                                <table  class="special" style="display: block;width: 100%;">
                                    <thead>
                                        <tr>
                                            <th scope="col" style="width: 400px;">Select</th>
                                            <th scope="col" style="width: 400px;">Type</th>
                                            <th scope="col" style="width: 400px;">Code</th>
                                            <th scope="col" style="width: 400px;">Name</th>
                                        </tr>
                                    </thead>
                                    <tbody style=" overflow-y: auto; display: block; width: 100%;">
                                        <tr mdbTableCol *ngFor="let routeTypeParent of routeTypeMap | keyvalue; let iParent = index"
                                          [ngClass]="[routeTypeRowExpanded[iParent] ? 'active' : '' ]">

                                            <div style="flex-direction: column">
                                              <label
                                                [ngClass]="[
                                                    routeTypeRowExpanded[iParent] ? 'active' : '',
                                                    routeTypeRowExpanded[iParent] ? 'colapsable' : 'colapsable'
                                                ]" (click)="colapsableLabelRouteType(iParent)" for="">{{routeTypeParent.key}}
                                                 <input type="checkbox" [checked]="checkIfAllSelected(routeTypeParent.key)"
                                                 (change)="changeSelectedParent(routeTypeParent.key, $event)" style="top: 2px !important; position: relative; left: 5px;">
                                              </label>
                                            </div>
                                            <ng-container *ngIf="routeTypeRowExpanded[iParent]">
                                              <tr *ngFor="let routeTypeChild of routeTypeParent.value; let iChild = index ">
                                                <td style="width: 400px;">
                                                    <input type="checkbox" [checked]="routeTypeChild.selected" (change)="changeSelectedChild(routeTypeParent.key, iChild)">
                                                </td>
                                                <td style="width: 400px;">{{routeTypeChild.type}}</td>
                                                <td style="width: 400px;">{{routeTypeChild.codeId}}</td>
                                                <td style="width: 400px;">{{routeTypeChild.txtDesig}}</td>
                                              </tr>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fields__btn">
                    <button (click)="proceedWithImport()" class="blue">Ok</button>

                    <button (click)="cancel();" class="blue" >Cancel</button>
                </div>
              </div>
        </div>
      </div>
  </div>

